import React, { useEffect, useState } from 'react';
import { SubNavigationLinkModel } from '../../Types/SubNavigationLinkModel';
import clsx from 'clsx';
import useReady from '../../Hooks/useReady';

const SubNavigationList = ({ links }: SubNavigationLinkModel) => {
  const isReady = useReady();
  return (
    <>
      {isReady ? (
        <div className="after-fade-to-white relative pb-0  after:absolute after:right-0 after:top-0 after:z-10 after:block after:h-[27px] after:w-10 lg:after:hidden md-down:-mr-4">
          <div className="flex gap-x-6 gap-y-3 scrollbar-none lg:flex-wrap md-down:overflow-y-scroll md-down:pr-10">
            {links?.map((link) => (
              <a
                href={link.url}
                className={clsx(
                  'underlined-link box-content whitespace-nowrap text-gray-700',
                  link.isSelected &&
                    'after:absolute after:bottom-0 after:left-0 after:right-0 after:h-[2px] after:w-full after:bg-gray-700 after:content-[""]'
                )}
                key={link.name + link.url}
              >
                {link.name}
              </a>
            ))}
          </div>
        </div>
      ) : (
        <div className="after-fade-to-white -mr-4 flex items-center gap-6 overflow-x-hidden pr-8 after:absolute after:right-0 after:block after:h-[27px] after:w-10">
          {links?.map((link) => {
            return (
              <a
                key={link.name + link.url}
                href={link.url}
                className={clsx(
                  'underlined-link box-content whitespace-nowrap text-gray-700',
                  link.isSelected &&
                    'after:absolute after:bottom-0 after:left-0 after:right-0 after:h-[2px] after:w-full after:bg-gray-700 after:content-[""]'
                )}
              >
                {link.name}
              </a>
            );
          })}
        </div>
      )}
    </>
  );
};

export default SubNavigationList;
